import React from 'react';
import { trackEvent } from '@src/services/analytics';
import { CatalogTagProps, PopoverTag } from '@src/components/PopoverTag';
import { GetMemberProgramQuery } from '@src/graphqlTypes/catalogServiceTypes';
import { EligibilityPopoverContent } from '../EligibilityPopoverContent';
import styles from './EligibilityTags.module.scss';

interface Props {
	failingTenureOnly: boolean;
	programUuid: GetMemberProgramQuery['memberProgram']['uuid'];
	tenureDays?: number;
}

export const EligibilityTags: React.FC<Props> = ({
	failingTenureOnly,
	programUuid,
	tenureDays,
}) => {
	const handleClick = (tagCopy: string) => {
		trackEvent('Clickable', {
			tag: 'program_details',
			text: tagCopy,
			type: 'popover',
		});
	};

	const tags: CatalogTagProps[] = [];

	if (failingTenureOnly) {
		tags.push({
			appearance: 'loud',
			color: 'green',
			copy: 'Eligible soon',
			copyColor: '#D4E1D5',
			iconColor: '#FEFEFD',
		});
	} else {
		tags.push({
			appearance: 'loud',
			color: 'yellow',
			copy: 'Not eligible',
			copyColor: '#170B01',
			iconColor: '#170B01',
		});
	}

	return (
		<div className={styles.tagWrapper}>
			{tags.map(tag => (
				<PopoverTag
					key={tag.copy}
					onClick={() => handleClick(tag.copy)}
					popoverContent={() => (
						<EligibilityPopoverContent tagCopy={tag.copy} tenureDays={tenureDays} />
					)}
					programUuid={programUuid}
					tag={tag}
				/>
			))}
		</div>
	);
};
